// Cache of panel thumbnail/texture data URLs, keyed by panel id.
//
// These are full-size base64 JPEGs, so a design with a few dozen panel models
// blows past the ~5MB sessionStorage quota. The in-memory Map is the source of
// truth (no quota); sessionStorage is only a best-effort mirror so a page
// reload in the same tab can serve textures before the images are re-fetched.

const memoryCache = new Map();

export const setPanelImage = (id, dataUrl) => {
  if (id === undefined || id === null || !dataUrl) return;

  const key = String(id);
  memoryCache.set(key, dataUrl);

  try {
    sessionStorage.setItem(key, dataUrl);
  } catch (_error) {
    // Quota exceeded (or storage disabled) — the memory cache still has it.
  }
};

export const getPanelImage = (id) => {
  if (id === undefined || id === null) return null;

  const key = String(id);
  if (memoryCache.has(key)) return memoryCache.get(key);

  try {
    const stored = sessionStorage.getItem(key);
    if (stored) memoryCache.set(key, stored);
    return stored;
  } catch (_error) {
    return null;
  }
};
